/* eslint-disable no-redeclare */
/* eslint-disable no-unused-vars */
/* eslint-disable no-inner-declarations */
// import * as THREE from "three";

// setup vars
var camera, scene, renderer, glass;
// const ratioGlassesMask = 16 / 9;
var leftMargin = 120;
var topMargin = 90;

var isUserInteracting = false,
  onPointerDownPointerX = 0,
  onPointerDownPointerY = 0,
  lon = 0,
  lat = 0,
  phi = 0,
  theta = 0;

function init(filePath) {
  var container, mesh, demo360;

  container = document.getElementById('container');
  demo360 = document.getElementById('.demo360');
  glass = document.querySelector('.glass');

  onWindowResize();

  // container.appendChild(renderer.domElement);
  // renderer.domElement.id = "canvas";
}

function addEventListeners() {
  // document.addEventListener("mousedown", onDocumentMouseDown, false);
  // document.addEventListener("mousemove", onDocumentMouseMove, false);
  // document.addEventListener("mouseup", onDocumentMouseUp, false);
  window.addEventListener('resize', onWindowResize, false);
}
function removeEventListeners() {
  // document.removeEventListener("mousedown", onDocumentMouseDown, false);
  // document.removeEventListener("mousemove", onDocumentMouseMove, false);
  // document.removeEventListener("mouseup", onDocumentMouseUp, false);
  window.removeEventListener('resize', onWindowResize, false);
}

function changeImg(filePath) {}

export function goFullScreen() {
  // camera.aspect = window.innerWidth / window.innerHeight;
  // camera.updateProjectionMatrix();
  // renderer.setSize(
  //   window.innerWidth - leftMargin * 2,
  //   (window.innerWidth - leftMargin * 2) / ratioGlassesMask
  // );
  // glass.style.width = window.innerWidth - leftMargin * 2 + "px";
  // glass.style.height =
  //   (window.innerWidth - leftMargin * 2) / ratioGlassesMask + "px";
}

export function computeSize() {
  let isFullScreen = false; // window.innerHeight === screen.height;
  const ratioGlassesMask = 16 / 9; // screen.width / screen.height;

  let width = isFullScreen ? window.innerWidth : window.innerWidth * (1 - 2 * 0.07); // 7vw

  let height = width / ratioGlassesMask;

  const maxHeight = isFullScreen ? window.innerHeight : window.innerHeight * (1 - 2 * 0.11); // 11vh

  // height = maxHeight;
  if (height > maxHeight) {
    height = maxHeight;
    width = height * ratioGlassesMask;
  }

  return { width, height };
}

function onWindowResize() {
  if (glass) {
    const size = computeSize();
    // camera.aspect = size.width / size.height;
    // camera.updateProjectionMatrix();
    // renderer.setSize(size.width, size.height);

    glass.style.width = size.width + 'px';
    glass.style.height = size.height + 'px';
  }
}

export { init, changeImg, addEventListeners, removeEventListeners, onWindowResize };
